import { lazy, Suspense } from 'react'

import {
  FullScreenLoader,
  ServiceLocationStepContainer as SharedServiceLocationStepContainer,
} from '@ngb-frontend/shared/ui'

import type {
  ServiceLocationStepAnyMergedData,
  ServiceLocationStepAnyStepData,
  StepComponentContainer,
} from '@ngb-frontend/shared/types'

const ServiceLocationStepLazy = lazy(() => import('./ServiceLocationStep'))

export const DriverServiceLocationStepContainer: StepComponentContainer<
  ServiceLocationStepAnyStepData,
  ServiceLocationStepAnyMergedData
> = (props) => {
  return (
    <Suspense fallback={<FullScreenLoader />}>
      <ServiceLocationStepLazy {...props} />
    </Suspense>
  )
}

DriverServiceLocationStepContainer.getVariant =
  SharedServiceLocationStepContainer.getVariant
DriverServiceLocationStepContainer.areStepPrerequisitesMet =
  SharedServiceLocationStepContainer.areStepPrerequisitesMet
DriverServiceLocationStepContainer.skip =
  SharedServiceLocationStepContainer.skip
